<div class="banner">
  <div class="col-12 pb-5">
    <h1>Billing</h1>
  </div>
  <div class="tab">
    <ul class="nav nav-tabs">

      <li><a [routerLink]="[{ outlets: { 'billing-tab': ['view-orders'] } }]" [routerLinkActive]="['active']"
          [routerLinkActiveOptions]="{ exact: true }">View Orders</a></li>

      <li *appNotAuthIf="[CognitoGroup.CarrierRegistrant, CognitoGroup.Carrier]">
        <a [routerLink]="[{ outlets: { 'billing-tab': ['needs-payment'] } }]" [routerLinkActive]="['active']"
          [routerLinkActiveOptions]="{ exact: true }">Needs Payment</a>
          <span *ngIf="needsPaymentCount && needsPaymentCount !== 0" id="needsPaymentBadge" class="badge rounded-pill">
            {{needsPaymentCount <= 99 ? needsPaymentCount : '&nbsp;!&nbsp;' }}
          </span>
        </li>

      <li *ngFor="let o of displayedOrders">
        <a [routerLink]="[{ outlets: { 'billing-tab': ['order', o] } }]" [routerLinkActive]="['active']"
          [routerLinkActiveOptions]="{ exact: true }">
          Order: {{o}}
          <button class="btn btn-sm btn-light" (click)="closeOrder($event, o);">X</button>
        </a>
      </li>

      <ng-container *ngIf="cachedAccount.monBillEnabled || cachedAccount.monthlyInvoiceExists">
        <li *appNotAuthIf="[CognitoGroup.CarrierRegistrant, CognitoGroup.Carrier]"><a
            [routerLink]="[{ outlets: { 'billing-tab': ['monthly-invoice'] } }]" [routerLinkActive]="['active']"
            [routerLinkActiveOptions]="{ exact: true }">Monthly Invoices</a>
          <span *ngIf="invoiceCount && invoiceCount !== 0" id="monthlyInvoicesBadge" class="badge rounded-pill">
            {{invoiceCount <= 99 ? invoiceCount : '&nbsp;!&nbsp;' }}
          </span>
        </li>
      </ng-container>

      <li *ngFor="let inv of displayedInvoices">
        <a [routerLink]="[{ outlets: { 'billing-tab': ['invoice', inv] } }]" [routerLinkActive]="['active']"
          [routerLinkActiveOptions]="{ exact: true }">
          Invoice: {{inv}}
          <button class="btn btn-sm btn-light" (click)="closeInvoice($event, inv);">X</button>
        </a>
      </li>

    </ul>
  </div>
</div>
<div class="tabcontent">
  <router-outlet (activate)="componentAdded($event)" name="billing-tab"></router-outlet>
</div>